// 認証が必要なルートを定義する
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

interface PrivateRouteProps {
  adminRequired?: boolean;
  children: React.ReactNode;
}

const PrivateRoute = ({
  adminRequired = false,
  children,
}: PrivateRouteProps) => {
  const authContext = useContext(AuthContext);
  const isAdmin = authContext?.role === 'ADMIN';
  const isAuthenticated = authContext?.isAuthenticated;
  const location = useLocation();

  // 未ログインの場合、ログイン画面へリダイレクト
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 一般ユーザーが管理者画面にアクセスしようとした場合、ログイン画面へリダイレクト
  if (adminRequired && !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  // 管理者が一般ユーザー画面にアクセスしようとした場合、ログイン画面へリダイレクト
  if (!adminRequired && isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
